import React, { useEffect, useState } from "react";
import {
    Box,
    Container,
    Grid,
    CircularProgress,
    CardActionArea,
    CardContent,
    Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "src/app/react/hooks/redux";
import { getProducts } from "src/app/react/redux/products/actions";
import { Auth } from "src/app/models/auth";
import { useStateCallback } from "src/app/react/hooks/useStateCallback";
import { Product } from 'src/app/react/models/product/product-response.model';
import { capitalizeFirstLetter } from "../../../shared/utils";
import { ProductCard, ProductName } from "./style";

interface ProductsPurchaseProps {
    selectedProducts: (selectedProducts: number[]) => void;
}

export const ProductsPurchase = ({ selectedProducts }: ProductsPurchaseProps) => {

    const dispatch = useAppDispatch();
    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));
    const productsCategory: any[] = JSON.parse(localStorage.getItem('productCategory'));

    const { products, error, loading } = useAppSelector(state => state.product);

    const [ selectedProduct, setSelectedProduct ] = useStateCallback([]);
    const [ selectedProductCheckbox, setSelectedProductCheckbox ] = useState<any>([]);

    useEffect(() => {
        if(products?.length <= 0)
            dispatch(getProducts(currentUser.token.assignorGuid, 0));
    },[]);

    useEffect(() => {
        const selectedProductCheckbox = [];
        products.map(x=>{
            selectedProductCheckbox.push({productId: x.productId, selected: false});
        })
        setSelectedProductCheckbox(selectedProductCheckbox);
    }, [products])

    const handleChange = (index: any, value: any) => {

        const updatedProducts = [...selectedProduct];
        const isChecked = updatedProducts.find(productId => productId === value);

        // const updatedProductCheckbox = selectedProductCheckbox.map((item, i) =>
        //     i === index ? !item : item
        // );        

        const updatedProductCheckbox = selectedProductCheckbox.map((item, i) => {
            if(item.productId === value) return {...item, selected: true}
            return {...item, selected: false};
        });

        setSelectedProductCheckbox(updatedProductCheckbox);

        if(!isChecked) {
            setSelectedProduct([value], () => {
                selectedProducts([value])
            })

            // setSelectedProduct([selectedProduct, value], () => {
            //     selectedProducts([...selectedProduct, value])
            // })
        }

        if(isChecked) {
            try {
                const productIndex = updatedProducts.findIndex(productId => productId === value);

                if(productIndex >= 0){
                    updatedProducts.splice(productIndex,1);

                    setSelectedProduct(updatedProducts, () => {
                        selectedProducts(updatedProducts)
                    });
                }else {
                  throw Error();
                }
              } catch {
                console.log('Erro na remoção do produto');
              }
        }
    }

    return (
        <>
            <Container disableGutters maxWidth={false}>
                <Typography variant="h6">Produtos</Typography>
                <Typography variant="subtitle1" >Selecione um produto</Typography>
                {loading &&
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Box sx={{textAlign: 'center'}}>
                                <CircularProgress />
                            </Box>
                        </Grid>
                    </Grid>
                }
                {!loading && 
                     <> 
                        {productsCategory.filter(x=>x.canList).map(category => (
                             <>                        
                                <Typography variant="h6" className="my-2">{category.categoryAssignorLabel}</Typography>                                
                                <Grid container spacing={{ xs: 2, md: 2 }}  columns={{ xs: 4, sm: 8, md: 12 }}>
                                    {products.filter(x=>x.productCategoryId === category.id).map((product: Product, index: any) => (
                                        <Grid item xs={12} sm={4} md={3} key={index}>
                                            <ProductCard selected={selectedProductCheckbox.find(x=>x.productId === product.productId)?.selected} color={product?.productColor} elevation={0}>
                                                <CardActionArea sx={{ display: 'flex', justifyContent: 'flex-start'}} onClick={() => handleChange(index, product?.productId)}>
                                                    <ProductName selected={selectedProductCheckbox.find(x=>x.productId === product.productId)?.selected} color={product.productColor} icon={product.productIcon}>   
                                                    <img className="imgIcon"
                                                        src={
                                                            product.productIcon ? 
                                                            product.productIcon  : 
                                                            "https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/SEMIMAGEM.svg"
                                                        }
                                                        alt="Live from space album cover"
                                                    />
                                                    </ProductName>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                        <CardContent sx={{ flex: '0 0 0' }}>
                                                            <Typography component="div" variant="body1" sx={{fontWeight: '500'}}>
                                                                { capitalizeFirstLetter(product.productDescription)}
                                                            </Typography>
                                                        </CardContent>
                                                    </Box>
                                                </CardActionArea>
                                            </ProductCard>
                                        </Grid>
                                    ))}                        
                                </Grid>
                            </>      
                        ))} 
                    </>
                }
            </Container>
        </>
    );
};
